/**
 * Mask a promoter's name for demos and screenshots ("Anthony NIOTOU" → "An*************").
 * Anything in parentheses (the sector) is preserved, since it carries no identity.
 *
 * Lives here rather than in VisitsViewer so a component can obfuscate without
 * importing the page — that import chain pulls the whole auth stack in.
 */
export const obfuscateUsername = (username) => {
  if (!username) return '—';

  const beforeParentheses = username.split('(')[0];
  const afterParentheses = username.includes('(') ? username.substring(username.indexOf('(')) : '';
  const obfuscatedPart = beforeParentheses.slice(0, 2) + '*'.repeat(Math.max(0, beforeParentheses.length - 2));

  return obfuscatedPart + afterParentheses;
};

export default obfuscateUsername;
